import { atom } from 'jotai'

export const toggleLivechat = atom(false)
